import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[10050] overflow-hidden overscroll-none flex items-center justify-center p-3 md:p-4"
}
const _hoisted_2 = { class: "flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2.5 sm:py-3 border-b border-gray-200 flex-shrink-0" }
const _hoisted_3 = { class: "min-w-0 flex-shrink-0" }
const _hoisted_4 = {
  key: 0,
  class: "text-[11px] text-gray-500 truncate max-w-[9rem] sm:max-w-none"
}
const _hoisted_5 = { class: "relative flex-1 max-w-md ml-auto min-w-0" }
const _hoisted_6 = ["aria-expanded", "onKeydown"]
const _hoisted_7 = {
  key: 1,
  class: "absolute left-0 right-0 top-full z-50 mt-1 max-h-64 overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg",
  role: "listbox"
}
const _hoisted_8 = {
  key: 0,
  class: "px-3 py-3 text-sm text-gray-500"
}
const _hoisted_9 = ["disabled", "onMousedown"]
const _hoisted_10 = { class: "truncate" }
const _hoisted_11 = {
  key: 0,
  class: "ml-auto flex-shrink-0 text-xs text-gray-500"
}
const _hoisted_12 = {
  key: 0,
  class: "text-[11px] sm:text-xs text-black font-medium whitespace-nowrap flex-shrink-0"
}
const _hoisted_13 = { class: "flex md:hidden flex-col border-b border-gray-100 flex-shrink-0 overscroll-contain" }
const _hoisted_14 = { class: "collapse-panel__inner" }
const _hoisted_15 = { class: "flex gap-2 px-3 pb-2 overflow-x-auto" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "opacity-80"
}
const _hoisted_18 = { class: "collapse-panel__inner" }
const _hoisted_19 = { class: "flex gap-2 px-3 pb-2 overflow-x-auto" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "opacity-80"
}
const _hoisted_22 = { class: "flex flex-1 min-h-0 overflow-hidden" }
const _hoisted_23 = { class: "hidden md:block w-44 lg:w-48 flex-shrink-0 bg-gray-50 border-r border-gray-200 overflow-y-auto overscroll-contain" }
const _hoisted_24 = { class: "collapse-panel__inner collapse-panel__inner--sidebar" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "truncate flex-1" }
const _hoisted_27 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_28 = { class: "collapse-panel__inner collapse-panel__inner--sidebar" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "truncate flex-1" }
const _hoisted_31 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_32 = {
  key: 0,
  class: "mb-3 p-2.5 bg-red-50 border border-red-300 rounded-lg text-xs text-red-700 font-medium"
}
const _hoisted_33 = {
  key: 0,
  class: "mb-3 p-2.5 bg-red-50 border border-red-300 rounded-lg text-xs text-red-700 font-medium"
}
const _hoisted_34 = {
  key: 2,
  class: "mb-4 space-y-2"
}
const _hoisted_35 = ["id"]
const _hoisted_36 = { class: "flex items-center justify-between gap-2 mb-2" }
const _hoisted_37 = { class: "text-sm font-medium text-black truncate" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "grid grid-cols-2 sm:grid-cols-3 gap-2"
}
const _hoisted_40 = { class: "text-xs text-black min-w-[2rem]" }
const _hoisted_41 = ["value", "onInput"]
const _hoisted_42 = {
  key: 3,
  class: "text-sm font-medium text-black mb-3 capitalize"
}
const _hoisted_43 = {
  key: 4,
  class: "text-sm text-gray-500 py-8 text-center"
}
const _hoisted_44 = {
  key: 5,
  class: "grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-4 sm:gap-x-6 sm:gap-y-5"
}
const _hoisted_45 = ["title", "disabled", "onClick"]
const _hoisted_46 = { class: "truncate" }
const _hoisted_47 = {
  key: 0,
  class: "text-[10px] text-gray-500"
}
const _hoisted_48 = {
  key: 0,
  class: "fas fa-check text-[10px] flex-shrink-0"
}
const _hoisted_49 = {
  key: 0,
  class: "absolute -top-1 -right-1 w-4 h-4 rounded-full bg-black text-white flex items-center justify-center shadow"
}
const _hoisted_50 = { class: "border-t border-gray-200 bg-white px-3 sm:px-4 py-3 flex-shrink-0" }
const _hoisted_51 = { class: "flex items-center justify-between gap-2" }
const _hoisted_52 = { class: "flex gap-2" }
const _hoisted_53 = ["onKeydown"]

import { computed, nextTick, ref, watch, onBeforeUnmount } from "vue";
import type { ProduitCatalogue } from "@/types";
import type { CouleurAPI } from "@/types/mel-components";
import {
  type BasicColorFamily,
  type BasicColorFamilyId,
  getColorSwatchStyle,
  getFamiliesWithVendorColors,
  groupVendorColorsByBasicFamily,
} from "@/utils/colorFamilies";
import {
  type MotifCategory,
  formatMotifPanelTitle,
  getMotifCategoriesWithColors,
  groupMotifsByCategory,
  splitSolidAndMotifColors,
} from "@/utils/motifFamilies";

type PickerSection = "couleurs" | "motifs";

export interface ColorOption {
  id_couleur: number;
  label: string;
  hexColor?: string | null;
  motifCategorie?: string | null;
  idCouleurEfashion?: number | null;
  officiel?: number | null;
}

interface ColorWithQuantities {
  id_couleur: number;
  quantitesParTaille?: number[];
}

interface Props {
  visible: boolean;
  product: ProduitCatalogue | null;
  colors: ColorOption[];
  selectedIds: number[];
  taillesList?: string[];
  venduPar?: string;
  colorsWithQuantities?: ColorWithQuantities[];
  disabledColorIds?: number[];
}

interface Emits {
  (e: "update:visible", value: boolean): void;
  (e: "add-color"): void;
  (
    e: "save",
    payload: {
      productId: number;
      selectedIds: number[];
      colorsWithQuantities?: ColorWithQuantities[];
    },
  ): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductColorsModal',
  props: {
    visible: { type: Boolean },
    product: {},
    colors: {},
    selectedIds: {},
    taillesList: {},
    venduPar: {},
    colorsWithQuantities: {},
    disabledColorIds: {}
  },
  emits: ["update:visible", "add-color", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const localSelectedIds = ref<number[]>([]);
const localColorsWithQuantities = ref<Map<number, number[]>>(new Map());
const searchQuery = ref("");
const searchInputRef = ref<HTMLInputElement | null>(null);
const saveButtonRef = ref<HTMLButtonElement | null>(null);
const isSearchDropdownOpen = ref(false);
const highlightedSearchIndex = ref(-1);
const activeSection = ref<PickerSection>("couleurs");
const activeFamilyId = ref<BasicColorFamilyId>("beige");
const activeMotifCategory = ref<MotifCategory>("Animaux");
const couleursSectionOpen = ref(true);
const motifsSectionOpen = ref(false);
const saveError = ref<string | null>(null);
const qtyErrorColorId = ref<number | null>(null);
const scrollSectionRef = ref<HTMLElement | null>(null);
const qtyAnchorRef = ref<HTMLElement | null>(null);

const scrollToQuantites = async (colorId?: number | null) => {
  await nextTick();
  const section = scrollSectionRef.value;
  if (!section) return;

  const target =
    (colorId != null
      ? document.getElementById(`qty-color-${colorId}`)
      : null) || qtyAnchorRef.value;

  if (target && section.contains(target)) {
    const targetRect = target.getBoundingClientRect();
    const sectionRect = section.getBoundingClientRect();
    const nextTop =
      section.scrollTop + (targetRect.top - sectionRect.top) - 8;
    section.scrollTo({ top: Math.max(0, nextTop), behavior: "smooth" });
  } else {
    section.scrollTo({ top: 0, behavior: "smooth" });
  }
};

const taillesList = computed(() => props.taillesList || []);

const showQuantitesParTaille = computed(
  () =>
    props.venduPar === "melangees" &&
    taillesList.value &&
    taillesList.value.length > 0,
);

const isSingleSelect = computed(
  () => props.venduPar === "couleurs" || props.venduPar === "tailles",
);

const disabledIds = computed(() =>
  (props.disabledColorIds || [])
    .map((id) => Number(id))
    .filter((n) => !Number.isNaN(n)),
);

const isColorDisabled = (id: number | string) =>
  disabledIds.value.includes(Number(id));

const colorsAsApi = computed<CouleurAPI[]>(() =>
  props.colors.map((c) => ({
    id_couleur: c.id_couleur,
    couleur_FR: c.label,
    couleur_EN: null,
    hexColor: c.hexColor ?? null,
    motifCategorie: c.motifCategorie ?? null,
    idCouleurEfashion: c.idCouleurEfashion ?? null,
    officiel: c.officiel ?? 1,
  })),
);

const solidColorsRef = computed(
  () => splitSolidAndMotifColors(colorsAsApi.value).solid,
);
const motifColorsRef = computed(
  () => splitSolidAndMotifColors(colorsAsApi.value).motifs,
);

const colorGroups = computed(() =>
  groupVendorColorsByBasicFamily(solidColorsRef.value),
);

const motifGroups = computed(() => groupMotifsByCategory(motifColorsRef.value));

const normalize = (s: string) =>
  (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}+/gu, "");

const matchesSearch = (color: CouleurAPI, term: string) =>
  normalize(color.couleur_FR || "").includes(term);

const searchResults = computed(() => {
  const term = normalize(searchQuery.value);
  if (!term) return [];
  return props.colors.filter(
    (color) =>
      !localSelectedIds.value.includes(color.id_couleur) &&
      normalize(color.label).includes(term),
  );
});

const visibleColorFamilies = computed(() => {
  if (searchQuery.value) {
    const term = normalize(searchQuery.value);
    return getFamiliesWithVendorColors(solidColorsRef.value).filter((family) =>
      (colorGroups.value[family.id] || []).some((color) =>
        matchesSearch(color, term),
      ),
    );
  }
  return getFamiliesWithVendorColors(solidColorsRef.value);
});

const visibleMotifCategories = computed(() => {
  if (searchQuery.value) {
    const term = normalize(searchQuery.value);
    return getMotifCategoriesWithColors(motifColorsRef.value).filter(
      (category) =>
        (motifGroups.value[category.id] || []).some((color) =>
          matchesSearch(color, term),
        ),
    );
  }
  return getMotifCategoriesWithColors(motifColorsRef.value);
});

const displayedShades = computed(() => {
  const term = searchQuery.value ? normalize(searchQuery.value) : "";

  if (activeSection.value === "motifs") {
    let list = (motifGroups.value[activeMotifCategory.value] || []).map(
      (color) => ({
        id_couleur: Number(color.id_couleur),
        label: color.couleur_FR || "",
        hexColor: color.hexColor ?? null,
      }),
    );
    if (term) list = list.filter((color) => normalize(color.label).includes(term));
    return list;
  }

  let list = (colorGroups.value[activeFamilyId.value] || []).map((color) => ({
    id_couleur: Number(color.id_couleur),
    label: color.couleur_FR || "",
    hexColor: color.hexColor ?? null,
  }));
  if (term) list = list.filter((color) => normalize(color.label).includes(term));
  return list;
});

const panelTitle = computed(() => {
  if (activeSection.value === "motifs") {
    return formatMotifPanelTitle(activeMotifCategory.value);
  }
  const family = visibleColorFamilies.value.find(
    (item) => item.id === activeFamilyId.value,
  );
  return family ? `Nuances de ${family.label.toLowerCase()}` : "";
});

const pendingCountByColorFamily = computed(() => {
  const counts: Partial<Record<BasicColorFamilyId, number>> = {};
  for (const family of visibleColorFamilies.value) {
    const count = (colorGroups.value[family.id] || []).filter((color) =>
      localSelectedIds.value.includes(Number(color.id_couleur)),
    ).length;
    if (count > 0) counts[family.id] = count;
  }
  return counts;
});

const pendingCountByMotifCategory = computed(() => {
  const counts: Partial<Record<MotifCategory, number>> = {};
  for (const category of visibleMotifCategories.value) {
    const count = (motifGroups.value[category.id] || []).filter((color) =>
      localSelectedIds.value.includes(Number(color.id_couleur)),
    ).length;
    if (count > 0) counts[category.id] = count;
  }
  return counts;
});

const isActiveNav = (section: PickerSection, id: string) =>
  activeSection.value === section &&
  (section === "couleurs"
    ? activeFamilyId.value === id
    : activeMotifCategory.value === id);

const navButtonClass = (section: PickerSection, id: string) =>
  isActiveNav(section, id)
    ? "bg-black text-white border-black"
    : "bg-white text-black border-gray-300";

const sidebarItemClass = (section: PickerSection, id: string) =>
  isActiveNav(section, id)
    ? "bg-white text-black font-medium shadow-sm"
    : "text-gray-700 hover:bg-white/70";

const selectColorFamily = (familyId: BasicColorFamilyId) => {
  activeSection.value = "couleurs";
  activeFamilyId.value = familyId;
  couleursSectionOpen.value = true;
  motifsSectionOpen.value = false;
};

const selectMotifCategory = (category: MotifCategory) => {
  activeSection.value = "motifs";
  activeMotifCategory.value = category;
  motifsSectionOpen.value = true;
  couleursSectionOpen.value = false;
};

const toggleCouleursSection = () => {
  const willOpen = !couleursSectionOpen.value;
  couleursSectionOpen.value = willOpen;
  if (willOpen) motifsSectionOpen.value = false;
};

const toggleMotifsSection = () => {
  const willOpen = !motifsSectionOpen.value;
  motifsSectionOpen.value = willOpen;
  if (willOpen) couleursSectionOpen.value = false;
};

const familySwatchStyle = (family: BasicColorFamily) => {
  if (family.swatch.startsWith("linear-gradient")) {
    return { backgroundImage: family.swatch };
  }
  return { backgroundColor: family.swatch };
};

const initPickerNavigation = () => {
  activeSection.value = "couleurs";
  activeFamilyId.value =
    getFamiliesWithVendorColors(solidColorsRef.value)[0]?.id || "beige";
  activeMotifCategory.value =
    getMotifCategoriesWithColors(motifColorsRef.value)[0]?.id || "Animaux";

  const solidFamilies = getFamiliesWithVendorColors(solidColorsRef.value);
  const motifCategories = getMotifCategoriesWithColors(motifColorsRef.value);

  if (solidFamilies.length > 0) {
    activeSection.value = "couleurs";
    activeFamilyId.value = solidFamilies[0].id;
    couleursSectionOpen.value = true;
    motifsSectionOpen.value = false;
  } else if (motifCategories.length > 0) {
    activeSection.value = "motifs";
    activeMotifCategory.value = motifCategories[0].id;
    couleursSectionOpen.value = false;
    motifsSectionOpen.value = true;
  }
};

const selectedColors = computed(() =>
  props.colors.filter((c) => localSelectedIds.value.includes(c.id_couleur)),
);

watch(
  () => props.visible,
  (val) => {
    document.body.style.overflow = val ? "hidden" : "";
    if (val) {
      searchQuery.value = "";
      saveError.value = null;
      qtyErrorColorId.value = null;
      initPickerNavigation();
      void nextTick(() => searchInputRef.value?.focus());
    }
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  document.body.style.overflow = "";
});

watch(
  () => props.selectedIds,
  (val) => {
    localSelectedIds.value = [...(val ?? [])];
  },
  { immediate: true },
);

watch(
  () => props.colorsWithQuantities,
  (val) => {
    if (val && Array.isArray(val)) {
      localColorsWithQuantities.value = new Map();
      val.forEach((c) => {
        if (c.quantitesParTaille) {
          localColorsWithQuantities.value.set(c.id_couleur, [
            ...c.quantitesParTaille,
          ]);
        }
      });
    }
  },
  { immediate: true, deep: true },
);

watch(
  () => [showQuantitesParTaille.value, props.taillesList] as const,
  ([shouldShow, tailles]) => {
    if (shouldShow && tailles && tailles.length > 0) {
      localSelectedIds.value.forEach((id) => {
        if (!localColorsWithQuantities.value.has(id)) {
          localColorsWithQuantities.value.set(
            id,
            new Array(tailles.length).fill(0),
          );
        } else {
          const currentQuantites =
            localColorsWithQuantities.value.get(id) || [];
          if (currentQuantites.length !== tailles.length) {
            const newQuantites = new Array(tailles.length).fill(0);
            currentQuantites.forEach((q, i) => {
              if (i < tailles.length) newQuantites[i] = q;
            });
            localColorsWithQuantities.value.set(id, newQuantites);
          }
        }
      });
    }
  },
  { immediate: true, deep: true },
);

watch(
  () => localSelectedIds.value,
  (newIds) => {
    if (
      showQuantitesParTaille.value &&
      taillesList.value &&
      taillesList.value.length > 0
    ) {
      newIds.forEach((id) => {
        if (!localColorsWithQuantities.value.has(id)) {
          localColorsWithQuantities.value.set(
            id,
            new Array(taillesList.value.length).fill(0),
          );
        }
      });
    }
  },
  { deep: true },
);

watch([visibleColorFamilies, visibleMotifCategories], ([families, categories]) => {
  if (
    activeSection.value === "couleurs" &&
    !families.find((family) => family.id === activeFamilyId.value)
  ) {
    if (families[0]) {
      activeFamilyId.value = families[0].id;
    } else if (categories[0]) {
      activeSection.value = "motifs";
      activeMotifCategory.value = categories[0].id;
      motifsSectionOpen.value = true;
      couleursSectionOpen.value = false;
    }
  }

  if (
    activeSection.value === "motifs" &&
    !categories.find((category) => category.id === activeMotifCategory.value)
  ) {
    if (categories[0]) {
      activeMotifCategory.value = categories[0].id;
    } else if (families[0]) {
      activeSection.value = "couleurs";
      activeFamilyId.value = families[0].id;
      couleursSectionOpen.value = true;
      motifsSectionOpen.value = false;
    }
  }
});

watch(searchQuery, () => {
  if (!searchQuery.value) return;
  if (visibleColorFamilies.value[0]) {
    activeSection.value = "couleurs";
    activeFamilyId.value = visibleColorFamilies.value[0].id;
    couleursSectionOpen.value = true;
    motifsSectionOpen.value = false;
    return;
  }
  if (visibleMotifCategories.value[0]) {
    activeSection.value = "motifs";
    activeMotifCategory.value = visibleMotifCategories.value[0].id;
    motifsSectionOpen.value = true;
    couleursSectionOpen.value = false;
  }
});

const toggleColor = (id: number) => {
  if (isColorDisabled(id)) return;

  const alreadySelected = localSelectedIds.value.includes(id);

  if (alreadySelected) {
    localSelectedIds.value = localSelectedIds.value.filter((x) => x !== id);
    localColorsWithQuantities.value.delete(id);
    saveError.value = null;
    return;
  }

  saveError.value = null;

  if (isSingleSelect.value) {
    localSelectedIds.value.forEach((oldId) =>
      localColorsWithQuantities.value.delete(oldId),
    );
    localSelectedIds.value = [id];
  } else {
    localSelectedIds.value = [...localSelectedIds.value, id];
  }

  if (
    showQuantitesParTaille.value &&
    taillesList.value &&
    taillesList.value.length > 0
  ) {
    localColorsWithQuantities.value.set(
      id,
      new Array(taillesList.value.length).fill(0),
    );
  }
};

const showSearchColorPage = (colorId: number) => {
  const motifCategory = visibleMotifCategories.value.find((category) =>
    (motifGroups.value[category.id] || []).some(
      (color) => Number(color.id_couleur) === colorId,
    ),
  );
  if (motifCategory) {
    selectMotifCategory(motifCategory.id);
    return;
  }
  const family = visibleColorFamilies.value.find((item) =>
    (colorGroups.value[item.id] || []).some(
      (color) => Number(color.id_couleur) === colorId,
    ),
  );
  if (family) selectColorFamily(family.id);
};

const selectSearchColor = (color: ColorOption) => {
  showSearchColorPage(color.id_couleur);
  toggleColor(color.id_couleur);
  clearSearch();
};

const clearSearch = () => {
  searchQuery.value = "";
  isSearchDropdownOpen.value = false;
  highlightedSearchIndex.value = -1;
  void nextTick(() => searchInputRef.value?.focus());
};

const openSearchDropdown = (event?: Event) => {
  const value =
    event?.target instanceof HTMLInputElement
      ? event.target.value
      : searchQuery.value;
  isSearchDropdownOpen.value = Boolean(value.trim());
};

const closeSearchDropdown = () => {
  isSearchDropdownOpen.value = false;
};

const moveSearchHighlight = (delta: number) => {
  isSearchDropdownOpen.value = true;
  const length = searchResults.value.length;
  if (!length) return;
  if (highlightedSearchIndex.value < 0) {
    highlightedSearchIndex.value = delta > 0 ? 0 : length - 1;
  } else {
    highlightedSearchIndex.value =
      (highlightedSearchIndex.value + delta + length) % length;
  }
};

const selectHighlightedSearchColor = () => {
  const color =
    searchResults.value[
      highlightedSearchIndex.value >= 0 ? highlightedSearchIndex.value : 0
    ];
  if (color && !isColorDisabled(color.id_couleur)) selectSearchColor(color);
};

const focusSaveButton = () => {
  closeSearchDropdown();
  saveButtonRef.value?.focus();
};

const focusSearchInput = () => {
  searchInputRef.value?.focus();
};

watch(searchQuery, () => {
  highlightedSearchIndex.value = -1;
});

const getQuantiteParTaille = (idCouleur: number, tailleIndex: number): number => {
  const quantites = localColorsWithQuantities.value.get(idCouleur);
  if (!quantites || !Array.isArray(quantites)) return 0;
  return quantites[tailleIndex] || 0;
};

const updateQuantiteParTaille = (
  idCouleur: number,
  tailleIndex: number,
  event: Event,
) => {
  const target = event.target as HTMLInputElement;
  const value = parseInt(target.value) || 0;

  if (value < 0) {
    target.value = "0";
    return;
  }

  if (!localColorsWithQuantities.value.has(idCouleur)) {
    localColorsWithQuantities.value.set(
      idCouleur,
      new Array(taillesList.value?.length || 0).fill(0),
    );
  }

  const quantites = localColorsWithQuantities.value.get(idCouleur)!;
  quantites[tailleIndex] = value;
  localColorsWithQuantities.value.set(idCouleur, [...quantites]);

  if (qtyErrorColorId.value === idCouleur) {
    qtyErrorColorId.value = null;
    saveError.value = null;
  }
};

const handleClose = () => {
  emit("update:visible", false);
};

const handleAddColor = () => {
  emit("add-color");
};

const handleSave = async () => {
  if (!props.product) return;

  saveError.value = null;
  qtyErrorColorId.value = null;

  if (localSelectedIds.value.length === 0) {
    saveError.value = "Veuillez sélectionner au moins une couleur.";
    return;
  }

  const colorsWithQuantities: ColorWithQuantities[] = [];
  if (showQuantitesParTaille.value) {
    const originalIds = new Set(props.selectedIds || []);
    const newlyAddedIds = localSelectedIds.value.filter(
      (id) => !originalIds.has(id),
    );

    localSelectedIds.value.forEach((id) => {
      const quantites = localColorsWithQuantities.value.get(id);
      if (quantites) {
        colorsWithQuantities.push({
          id_couleur: id,
          quantitesParTaille: [...quantites],
        });
      }
    });

    for (const newId of newlyAddedIds) {
      const quantites = localColorsWithQuantities.value.get(newId);
      const total = quantites
        ? quantites.reduce((sum, q) => sum + (q || 0), 0)
        : 0;
      if (total === 0) {
        const color = props.colors.find((c) => c.id_couleur === newId);
        saveError.value = `La couleur "${color?.label || newId}" doit avoir un stock supérieur à 0.`;
        qtyErrorColorId.value = newId;
        await scrollToQuantites(newId);
        return;
      }
    }
  }

  emit("save", {
    productId: props.product.id,
    selectedIds: localSelectedIds.value,
    colorsWithQuantities:
      colorsWithQuantities.length > 0 ? colorsWithQuantities : undefined,
  });
  emit("update:visible", false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-black/40",
              onClick: handleClose,
              onWheel: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
              onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, null, 32),
            _createElementVNode("div", {
              class: "relative z-[10060] w-full max-w-4xl bg-white rounded-2xl shadow-xl border border-gray-100 flex flex-col h-[85dvh] md:h-auto md:max-h-[90vh] overflow-hidden",
              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
              onWheel: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
              onTouchmove: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-base sm:text-lg font-semibold text-black whitespace-nowrap" }, " Couleurs/motifs ", -1)),
                  (_ctx.product)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.product.reference), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs" }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    ref_key: "searchInputRef",
                    ref: searchInputRef,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                    type: "text",
                    autocomplete: "off",
                    placeholder: "Rechercher une couleur",
                    class: "w-full pl-9 pr-9 py-2 text-sm border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-black focus:border-black",
                    role: "combobox",
                    "aria-expanded": isSearchDropdownOpen.value,
                    onFocus: openSearchDropdown,
                    onInput: openSearchDropdown,
                    onBlur: closeSearchDropdown,
                    onKeydown: [
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (moveSearchHighlight(1)), ["prevent"]), ["down"])),
                      _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (moveSearchHighlight(-1)), ["prevent"]), ["up"])),
                      _withKeys(_withModifiers(selectHighlightedSearchColor, ["prevent"]), ["enter"]),
                      _withKeys(_withModifiers(focusSaveButton, ["exact","prevent"]), ["tab"])
                    ]
                  }, null, 40, _hoisted_6), [
                    [
                      _vModelText,
                      searchQuery.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (searchQuery.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        tabindex: "-1",
                        class: "absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-full p-1 text-gray-400 hover:text-black",
                        "aria-label": "Effacer la recherche",
                        onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                        onClick: clearSearch
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-times text-xs" }, null, -1)
                      ]), 32))
                    : _createCommentVNode("", true),
                  (isSearchDropdownOpen.value && searchQuery.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (!searchResults.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Aucune couleur trouvée "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (color, index) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: `search-${color.id_couleur}`,
                            type: "button",
                            tabindex: "-1",
                            class: _normalizeClass(["flex w-full items-center gap-2 border-b border-gray-100 px-3 py-2 text-left text-sm last:border-b-0", [
                  index === highlightedSearchIndex.value ? 'bg-blue-100' : 'hover:bg-gray-100',
                  isColorDisabled(color.id_couleur) ? 'opacity-50' : '',
                ]]),
                            disabled: isColorDisabled(color.id_couleur),
                            onMousedown: _withModifiers(($event: any) => (selectSearchColor(color)), ["prevent"])
                          }, [
                            _createElementVNode("span", {
                              class: "color-swatch-dot h-4 w-4 flex-shrink-0 rounded-full",
                              style: _normalizeStyle(_unref(getColorSwatchStyle)(color.label, color.hexColor))
                            }, null, 4),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(color.label), 1),
                            (isColorDisabled(color.id_couleur))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Utilisée"))
                              : _createCommentVNode("", true)
                          ], 42, _hoisted_9))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (localSelectedIds.value.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(localSelectedIds.value.length) + " sél. ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "text-gray-500 hover:text-black p-2 flex-shrink-0",
                  "aria-label": "Fermer",
                  onClick: handleClose
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_13, [
                (visibleColorFamilies.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center justify-between px-3 py-2 text-sm font-bold text-black uppercase tracking-wide",
                        onClick: toggleCouleursSection
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "Couleurs", -1)),
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': couleursSectionOpen.value }])
                        }, null, 2)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["collapse-panel", couleursSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColorFamilies.value, (family) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: 'mc-' + family.id,
                                type: "button",
                                class: _normalizeClass(["flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs whitespace-nowrap border flex-shrink-0 transition-colors", navButtonClass('couleurs', family.id)]),
                                onClick: ($event: any) => (selectColorFamily(family.id))
                              }, [
                                _createElementVNode("span", {
                                  class: "color-swatch-dot w-3.5 h-3.5 rounded-full flex-shrink-0",
                                  style: _normalizeStyle(familySwatchStyle(family))
                                }, null, 4),
                                _createTextVNode(" " + _toDisplayString(family.label) + " ", 1),
                                (pendingCountByColorFamily.value[family.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(" + _toDisplayString(pendingCountByColorFamily.value[family.id]) + ")", 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_16))
                            }), 128))
                          ])
                        ])
                      ], 2)
                    ], 64))
                  : _createCommentVNode("", true),
                (visibleMotifCategories.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["flex items-center justify-between px-3 py-2 text-sm font-bold text-black uppercase tracking-wide", visibleColorFamilies.value.length ? 'border-t border-gray-100' : '']),
                        onClick: toggleMotifsSection
                      }, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "Motifs", -1)),
                        _createElementVNode("i", {
                          class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': motifsSectionOpen.value }])
                        }, null, 2)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["collapse-panel", motifsSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMotifCategories.value, (category) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: 'mm-' + category.id,
                                type: "button",
                                class: _normalizeClass(["flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs whitespace-nowrap border flex-shrink-0 transition-colors", navButtonClass('motifs', category.id)]),
                                onClick: ($event: any) => (selectMotifCategory(category.id))
                              }, [
                                _createTextVNode(_toDisplayString(category.label) + " ", 1),
                                (pendingCountByMotifCategory.value[category.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(" + _toDisplayString(pendingCountByMotifCategory.value[category.id]) + ")", 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_20))
                            }), 128))
                          ])
                        ])
                      ], 2)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("aside", _hoisted_23, [
                  (visibleColorFamilies.value.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "w-full flex items-center justify-between px-3 py-2.5 text-sm font-bold text-black uppercase tracking-wide hover:bg-white/70 transition-colors",
                          onClick: toggleCouleursSection
                        }, [
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "Couleurs", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': couleursSectionOpen.value }])
                          }, null, 2)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["collapse-panel", couleursSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColorFamilies.value, (family) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: family.id,
                                type: "button",
                                class: _normalizeClass(["w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition-colors", sidebarItemClass('couleurs', family.id)]),
                                onClick: ($event: any) => (selectColorFamily(family.id))
                              }, [
                                _createElementVNode("span", {
                                  class: "color-swatch-dot w-5 h-5 rounded-full flex-shrink-0",
                                  style: _normalizeStyle(familySwatchStyle(family))
                                }, null, 4),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(family.label), 1),
                                (pendingCountByColorFamily.value[family.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, " (" + _toDisplayString(pendingCountByColorFamily.value[family.id]) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_25))
                            }), 128))
                          ])
                        ], 2)
                      ], 64))
                    : _createCommentVNode("", true),
                  (visibleMotifCategories.value.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["w-full flex items-center justify-between px-3 py-2.5 text-sm font-bold text-black uppercase tracking-wide hover:bg-white/70 transition-colors", visibleColorFamilies.value.length ? 'border-t border-gray-200' : '']),
                          onClick: toggleMotifsSection
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", null, "Motifs", -1)),
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas fa-chevron-down collapse-chevron text-[10px] text-gray-400", { 'collapse-chevron--open': motifsSectionOpen.value }])
                          }, null, 2)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["collapse-panel", motifsSectionOpen.value ? 'collapse-panel--open' : 'collapse-panel--closed'])
                        }, [
                          _createElementVNode("div", _hoisted_28, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMotifCategories.value, (category) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: category.id,
                                type: "button",
                                class: _normalizeClass(["w-full flex items-center gap-2.5 px-3 py-2.5 text-sm text-left transition-colors", sidebarItemClass('motifs', category.id)]),
                                onClick: ($event: any) => (selectMotifCategory(category.id))
                              }, [
                                _createElementVNode("span", _hoisted_30, _toDisplayString(category.label), 1),
                                (pendingCountByMotifCategory.value[category.id])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " (" + _toDisplayString(pendingCountByMotifCategory.value[category.id]) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_29))
                            }), 128))
                          ])
                        ], 2)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", {
                  ref_key: "scrollSectionRef",
                  ref: scrollSectionRef,
                  class: "flex-1 overflow-y-auto overscroll-contain p-3 sm:p-5 min-h-0"
                }, [
                  (saveError.value && !showQuantitesParTaille.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(saveError.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (showQuantitesParTaille.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: "qty-anchor",
                        ref_key: "qtyAnchorRef",
                        ref: qtyAnchorRef,
                        class: "scroll-mt-2"
                      }, [
                        (saveError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(saveError.value), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mb-3 rounded-lg border border-blue-200 bg-blue-50/80 p-2.5 text-xs text-blue-800" }, [
                          _createElementVNode("i", { class: "fas fa-info-circle mr-1" }),
                          _createTextVNode(" Couleurs mélangées : définissez les quantités par taille pour chaque couleur sélectionnée. ")
                        ], -1))
                      ], 512))
                    : _createCommentVNode("", true),
                  (showQuantitesParTaille.value && selectedColors.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-xs font-semibold text-gray-500 uppercase tracking-wide" }, " Sélectionnées — quantités ", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedColors.value, (color) => {
                          return (_openBlock(), _createElementBlock("div", {
                            id: 'qty-color-' + color.id_couleur,
                            key: 'qty-' + color.id_couleur,
                            class: _normalizeClass(["rounded-lg border bg-white p-2.5 scroll-mt-2 transition-colors", 
                  qtyErrorColorId.value === color.id_couleur
                    ? 'border-red-400 ring-1 ring-red-400'
                    : 'border-gray-200'
                ])
                          }, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("span", _hoisted_37, _toDisplayString(color.label), 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-xs text-gray-400 hover:text-black",
                                onClick: ($event: any) => (toggleColor(color.id_couleur))
                              }, " ✕ ", 8, _hoisted_38)
                            ]),
                            (taillesList.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taillesList.value, (taille, tailleIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: tailleIndex,
                                      class: "flex items-center gap-2"
                                    }, [
                                      _createElementVNode("label", _hoisted_40, _toDisplayString(taille), 1),
                                      _createElementVNode("input", {
                                        type: "number",
                                        value: getQuantiteParTaille(color.id_couleur, tailleIndex),
                                        min: "0",
                                        placeholder: "0",
                                        class: "w-full px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-black text-center",
                                        onInput: ($event: any) => (updateQuantiteParTaille(color.id_couleur, tailleIndex, $event))
                                      }, null, 40, _hoisted_41)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_35))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (panelTitle.value)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_42, _toDisplayString(panelTitle.value), 1))
                    : _createCommentVNode("", true),
                  (displayedShades.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(searchQuery.value
                  ? "Aucune couleur trouvée"
                  : activeSection.value === "motifs"
                    ? "Aucun motif dans cette famille"
                    : "Aucune couleur dans cette famille"), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedShades.value, (color) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: color.id_couleur,
                            type: "button",
                            class: _normalizeClass(["group text-left focus:outline-none", [
                  isColorDisabled(color.id_couleur)
                    ? 'opacity-40 cursor-not-allowed'
                    : '',
                  activeSection.value === 'motifs'
                    ? localSelectedIds.value.includes(color.id_couleur)
                      ? 'rounded-md border border-black ring-1 ring-black px-2.5 py-2'
                      : 'rounded-md border border-gray-200 px-2.5 py-2 hover:border-gray-400'
                    : '',
                ]]),
                            title: 
                  isColorDisabled(color.id_couleur)
                    ? 'Cette couleur est déjà utilisée par un autre produit de la même liaison'
                    : ''
                ,
                            disabled: isColorDisabled(color.id_couleur),
                            onClick: ($event: any) => (toggleColor(color.id_couleur))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-xs sm:text-sm text-black truncate flex items-center justify-between gap-2", activeSection.value === 'motifs' ? '' : 'mb-1.5'])
                            }, [
                              _createElementVNode("span", _hoisted_46, [
                                _createTextVNode(_toDisplayString(color.label) + " ", 1),
                                (isColorDisabled(color.id_couleur))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "(utilisée)"))
                                  : _createCommentVNode("", true)
                              ]),
                              (
                      activeSection.value === 'motifs' &&
                      localSelectedIds.value.includes(color.id_couleur)
                    )
                                ? (_openBlock(), _createElementBlock("i", _hoisted_48))
                                : _createCommentVNode("", true)
                            ], 2),
                            (activeSection.value !== 'motifs')
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["relative w-full h-12 sm:h-16 rounded-md border overflow-hidden transition-all", 
                    localSelectedIds.value.includes(color.id_couleur)
                      ? 'border-black ring-1 ring-black'
                      : 'border-gray-200 group-hover:border-gray-400'
                  ]),
                                  style: _normalizeStyle(_unref(getColorSwatchStyle)(color.label, color.hexColor))
                                }, [
                                  (localSelectedIds.value.includes(color.id_couleur))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, _cache[21] || (_cache[21] = [
                                        _createElementVNode("i", { class: "fas fa-check text-[8px]" }, null, -1)
                                      ])))
                                    : _createCommentVNode("", true)
                                ], 6))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_45))
                        }), 128))
                      ]))
                ], 512)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "px-3 sm:px-4 py-2 text-sm border border-teal-600 text-teal-700 rounded-lg hover:bg-teal-50 transition-colors flex items-center gap-2",
                    onClick: handleAddColor
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([
                  'fas text-xs',
                  _ctx.venduPar === 'melangees' ? 'fa-camera' : 'fa-palette',
                ])
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(_ctx.venduPar === "melangees" ? "Nouvelle photo" : "Nouvelle couleur"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "px-4 py-2 text-sm border border-gray-800 rounded-lg hover:bg-gray-50 transition-colors",
                      onClick: handleClose
                    }, " Annuler "),
                    _createElementVNode("button", {
                      ref_key: "saveButtonRef",
                      ref: saveButtonRef,
                      type: "button",
                      class: "px-4 py-2 text-sm bg-black text-white rounded-lg hover:bg-gray-800 transition-colors",
                      onClick: handleSave,
                      onKeydown: _withKeys(_withModifiers(focusSearchInput, ["exact","prevent"]), ["tab"])
                    }, " Enregistrer ", 40, _hoisted_53)
                  ])
                ])
              ])
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})